import React from 'react';
import { Row, Col } from 'react-bootstrap';

import Ratings from './Ratings';

const QuickOverview = () => (
  <div className="Footer-Overview">
    <Row>
      <Col md={7}>
        <h4 className="Footer-Overview__SubTitle">Need Computer Help? Call Us 24/7</h4>
        <a href="tel:1300912176" className="Footer-Overview__SupportNumber">
          1300 912 176
        </a>
      </Col>
      <Col md={5}>
        <Ratings />
      </Col>
    </Row>
  </div>
);

export default QuickOverview;